import React, { useState, useEffect } from 'react'
import { css } from 'emotion'
import EirButton from '../eir-button/EirButton'
import { Container } from 'reactstrap';

import { TabContent, TabPane, Nav, NavItem, NavLink, Card, Button, CardTitle, CardText, Row, Col } from 'reactstrap';
import classnames from 'classnames';
import styled from '@emotion/styled'
import { isMobileOnly } from 'react-device-detect';
import VideoModal from '../video-modal/VideoModal';

const TutorialTile = (props) => {


    const renderContent = (content) => {
        return { __html: content };
    }

    const [isOpen, setIsOpen] = useState(false);
    const toggle = () => {
      setIsOpen(!isOpen);
    }

    const CloseVideo = () => {
      setIsOpen(false);
    }


    return (
        <div>
    
          <Row className="d-flex align-items-center p-4 col-12" >
            <Col className="col-10">
            <div className=" " dangerouslySetInnerHTML={renderContent(props.tile.Text)}></div>         
            </Col>
            {props.tile.image &&
              <Col className="col-2">
                <img onClick={toggle}  className="mobile-tile-icon" src={props.tile.image.path}></img>
              </Col>
            }
            </Row>
            <VideoModal videoUrl={props.tile.videoLink} videoPopup={isOpen} toggleVideoPopup={CloseVideo}></VideoModal>    
            </div>
    )
}


export default TutorialTile